import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = {
    key: 0,
    class: "form-menu"
};
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "form-contents" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "clearfix" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_10 = { class: "input-group top_search" };
const _hoisted_11 = { class: "input-group-btn" };
const _hoisted_12 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-5"
};
const _hoisted_13 = { class: "input-group top_search" };
const _hoisted_14 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_15 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_16 = { class: "float-end left5" };
const _hoisted_17 = { class: "clearfix pad10" };
const _hoisted_18 = { class: "float-end" };
const _hoisted_19 = {
    key: 0,
    class: "float-end"
};
const _hoisted_20 = { class: "float-end hidden-xs record-count" };
const _hoisted_21 = { class: "clearfix" };
const _hoisted_22 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_23 = {
    class: "nav nav-tabs",
    role: "tablist"
};
const _hoisted_24 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_25 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_26 = {
    class: "nav-item",
    role: "presentation"
};
const _hoisted_27 = { class: "col-xs-12 col-sm-12" };
const _hoisted_28 = { class: "card bg-white data-grid manufacturers-grid detached overflow-x-auto top0" };
const _hoisted_29 = { class: "table table-hover bottom0 pw100" };
const _hoisted_30 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_31 = { class: "text-center hidden-sm" };
const _hoisted_32 = { key: 0 };
const _hoisted_33 = { key: 0 };
const _hoisted_34 = { class: "col-xs-12 col-sm-12" };
const _hoisted_35 = { class: "card bg-white data-grid manufacturers-grid detached overflow-x-auto top0" };
const _hoisted_36 = { class: "table table-hover bottom0 pw100" };
const _hoisted_37 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_38 = { class: "text-center hidden-sm" };
const _hoisted_39 = { key: 0 };
const _hoisted_40 = { key: 0 };
const _hoisted_41 = { class: "col-xs-12 col-sm-12" };
const _hoisted_42 = { class: "card bg-white data-grid models-grid detached overflow-x-auto top0" };
const _hoisted_43 = { class: "table table-hover bottom0 pw100" };
const _hoisted_44 = {
    key: 0,
    class: "text-center hidden-sm w40 no-min-width"
};
const _hoisted_45 = { class: "text-center hidden-sm" };
const _hoisted_46 = { key: 0 };
const _hoisted_47 = { class: "clearfix visible-sm" };
const _hoisted_48 = { key: 0 };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_form_checkbox = _resolveComponent("b-form-checkbox");
    const _component_b_form_group = _resolveComponent("b-form-group");
    const _component_b_dropdown_form = _resolveComponent("b-dropdown-form");
    const _component_b_dropdown_divider = _resolveComponent("b-dropdown-divider");
    const _component_b_dropdown = _resolveComponent("b-dropdown");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_dropdown_item = _resolveComponent("b-dropdown-item");
    const _component_b_button_group = _resolveComponent("b-button-group");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle), 1 /* TEXT */)
            ]),
            _cache[10] || (_cache[10] = _createTextVNode()),
            (_ctx.query.companyId)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        (_ctx.viewMode !== 'batteryMonitor')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId }, query: { manufacturerTypeId: _ctx.currentManufacturerTypeId } }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Add Manufacturer", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]))
                            : _createCommentVNode("v-if", true),
                        _cache[9] || (_cache[9] = _createTextVNode()),
                        (_ctx.viewMode === 'batteryMonitor')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 1,
                                to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0 } }
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_b_button, { variant: "primary" }, {
                                        default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                                _createElementVNode("span", { class: "hidden-xs" }, " Add Battery Monitor Model", -1 /* CACHED */)
                                            ]))]),
                                        _: 1 /* STABLE */
                                    })
                                ]),
                                _: 1 /* STABLE */
                            }, 8 /* PROPS */, ["to"]))
                            : _createCommentVNode("v-if", true)
                    ])
                ]))
                : _createCommentVNode("v-if", true)
        ]),
        _cache[65] || (_cache[65] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.currentQuery.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.currentQuery.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[12] || (_cache[12] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_11, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[11] || (_cache[11] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ]),
                    _cache[23] || (_cache[23] = _createTextVNode()),
                    (_ctx.companies.length > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            _createElementVNode("div", _hoisted_13, [
                                _createVNode(_component_multiselect, {
                                    modelValue: _ctx.company,
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.company) = $event)),
                                    options: _ctx.companies,
                                    "track-by": "value",
                                    label: "text",
                                    showLabels: false,
                                    placeholder: "Select a Company",
                                    class: "multiselect-small"
                                }, {
                                    noResult: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                            _createTextVNode("\r\n\t\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                        ]))]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["modelValue", "options"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true),
                    _cache[24] || (_cache[24] = _createTextVNode()),
                    _createElementVNode("div", {
                        class: _normalizeClass(['col-xs-12 col-sm-12', _ctx.companies.length > 1 ? 'col-md-3' : 'col-md-8'])
                    }, [
                        (_ctx.searchAttempted)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    _createElementVNode("div", _hoisted_16, [
                                        _createVNode(_component_b_dropdown, {
                                            ref: "columnSettingsDropdown",
                                            "no-caret": "",
                                            end: "",
                                            sm: "",
                                            "auto-close": false,
                                            variant: "outline-secondary outline-secondary-pagination",
                                            disabled: _ctx.working
                                        }, {
                                            "button-content": _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                                    _createElementVNode("i", { class: "fa fa-cog" }, null, -1 /* CACHED */)
                                                ]))]),
                                            default: _withCtx(() => [
                                                _cache[18] || (_cache[18] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_form, { class: "column-settings-dropdown" }, {
                                                    default: _withCtx(() => [
                                                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "clearfix top10" }, [
                                                            _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\tColumn visibility\r\n\t\t\t\t\t\t\t\t\t\t\t\t")
                                                        ], -1 /* CACHED */)),
                                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentColumns, (column, columnIdx) => {
                                                            return (_openBlock(), _createBlock(_component_b_form_group, {
                                                                key: column.fieldName
                                                            }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_component_b_form_group, null, {
                                                                        default: _withCtx(() => [
                                                                            _createVNode(_component_b_form_checkbox, {
                                                                                id: column.fieldName,
                                                                                modelValue: column.visible,
                                                                                "onUpdate:modelValue": ($event) => ((column.visible) = $event)
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(column.title), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "modelValue", "onUpdate:modelValue"])
                                                                        ]),
                                                                        _: 2 /* DYNAMIC */
                                                                    }, 1024 /* DYNAMIC_SLOTS */)
                                                                ]),
                                                                _: 2 /* DYNAMIC */
                                                            }, 1024 /* DYNAMIC_SLOTS */));
                                                        }), 128 /* KEYED_FRAGMENT */))
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }),
                                                _cache[19] || (_cache[19] = _createTextVNode()),
                                                _createVNode(_component_b_dropdown_divider),
                                                _cache[20] || (_cache[20] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("div", _hoisted_18, [
                                                        _createVNode(_component_b_button, {
                                                            variant: "secondary",
                                                            right: "",
                                                            sm: "",
                                                            onClick: _ctx.closeColumnSettingsMenu
                                                        }, {
                                                            default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                                    _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                                                    _createTextVNode(" Close\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                ]))]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["onClick"])
                                                    ])
                                                ])
                                            ]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["disabled"])
                                    ]),
                                    _cache[21] || (_cache[21] = _createTextVNode()),
                                    (_ctx.numberOfVisibleColumns)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                            _createVNode(_component_b_pagination, {
                                                class: "float-end",
                                                modelValue: _ctx.currentQuery.pageNo,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.currentQuery.pageNo) = $event)),
                                                "per-page": _ctx.currentQuery.pageSize,
                                                "total-rows": _ctx.currentData.recordCount,
                                                "hide-ellipsis": true,
                                                disabled: _ctx.working
                                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                                        ]))
                                        : _createCommentVNode("v-if", true),
                                    _cache[22] || (_cache[22] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_20, "\r\n\t\t\t\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.currentData.recordCount), 1 /* TEXT */)
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ], 2 /* CLASS */)
                ]),
                _cache[58] || (_cache[58] = _createTextVNode()),
                _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("ul", _hoisted_23, [
                            _createElementVNode("li", _hoisted_24, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'battery' }]),
                                    onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.viewMode = 'battery')),
                                    type: "button",
                                    role: "tab"
                                }, [...(_cache[25] || (_cache[25] = [
                                        _createElementVNode("i", { class: "fa fa-battery-full" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Battery\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ]),
                            _cache[28] || (_cache[28] = _createTextVNode()),
                            _createElementVNode("li", _hoisted_25, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'upsCharger' }]),
                                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.viewMode = 'upsCharger')),
                                    type: "button",
                                    role: "tab"
                                }, [...(_cache[26] || (_cache[26] = [
                                        _createElementVNode("i", { class: "fa fa-plug" }, null, -1 /* CACHED */),
                                        _createTextVNode(" UPS/Charger\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ]),
                            _cache[29] || (_cache[29] = _createTextVNode()),
                            _createElementVNode("li", _hoisted_26, [
                                _createElementVNode("button", {
                                    class: _normalizeClass(["nav-link", { active: _ctx.viewMode === 'batteryMonitor' }]),
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.viewMode = 'batteryMonitor')),
                                    type: "button",
                                    role: "tab"
                                }, [...(_cache[27] || (_cache[27] = [
                                        _createElementVNode("i", { class: "fa fa-microchip" }, null, -1 /* CACHED */),
                                        _createTextVNode(" Battery Monitor\r\n\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                    ]))], 2 /* CLASS */)
                            ])
                        ])
                    ])
                ]),
                _cache[59] || (_cache[59] = _createTextVNode()),
                _createCommentVNode(" Battery Manufacturers Table "),
                _cache[60] || (_cache[60] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("table", _hoisted_29, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('ManufacturerName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_30))
                                        : _createCommentVNode("v-if", true),
                                    _cache[30] || (_cache[30] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ManufacturerName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[37] || (_cache[37] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturersData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_31, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[33] || (_cache[33] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[34] || (_cache[34] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteManufacturer(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[35] || (_cache[35] = _createTextVNode()),
                                        (_ctx.isVisible('ManufacturerName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_32, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId, 'id': item.manufacturerId }, query: { manufacturerTypeId: item.manufacturerTypeId } },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.manufacturerName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[38] || (_cache[38] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_33, [...(_cache[36] || (_cache[36] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "2"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'battery']
                ]),
                _cache[61] || (_cache[61] = _createTextVNode()),
                _createCommentVNode(" UPS/Charger Manufacturers Table "),
                _cache[62] || (_cache[62] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("table", _hoisted_36, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisible('ManufacturerName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_37))
                                        : _createCommentVNode("v-if", true),
                                    _cache[39] || (_cache[39] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.sorter,
                                            column: { fieldName: 'ManufacturerName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[46] || (_cache[46] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manufacturersData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_38, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.edit(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.edit(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[42] || (_cache[42] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[43] || (_cache[43] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteManufacturer(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[44] || (_cache[44] = _createTextVNode()),
                                        (_ctx.isVisible('ManufacturerName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_39, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'manufacturer', params: { 'companyId': _ctx.query.companyId, 'id': item.manufacturerId }, query: { manufacturerTypeId: item.manufacturerTypeId } },
                                                    class: "blue"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.manufacturerName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[47] || (_cache[47] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_40, [...(_cache[45] || (_cache[45] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "2"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'upsCharger']
                ]),
                _cache[63] || (_cache[63] = _createTextVNode()),
                _createCommentVNode(" Battery Monitor (Controller Models) Table "),
                _cache[64] || (_cache[64] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("table", _hoisted_43, [
                            _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    (_ctx.isVisibleModel('ModelName'))
                                        ? (_openBlock(), _createElementBlock("th", _hoisted_44))
                                        : _createCommentVNode("v-if", true),
                                    _cache[48] || (_cache[48] = _createTextVNode()),
                                    _createElementVNode("th", null, [
                                        _createVNode(_component_SortableColumnComponent, {
                                            sorter: _ctx.modelsSorter,
                                            column: { fieldName: 'ModelName', title: 'Name' }
                                        }, null, 8 /* PROPS */, ["sorter"])
                                    ])
                                ])
                            ]),
                            _cache[56] || (_cache[56] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelsData.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", _hoisted_45, [
                                            _createVNode(_component_b_button_group, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_b_dropdown, {
                                                        variant: "outline-secondary dots",
                                                        size: "sm",
                                                        onClick: ($event) => (_ctx.editModel(item))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.editModel(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                                                                        _createElementVNode("span", { class: "fa fa-pencil" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Edit\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"]),
                                                            _cache[51] || (_cache[51] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_divider),
                                                            _cache[52] || (_cache[52] = _createTextVNode()),
                                                            _createVNode(_component_b_dropdown_item, {
                                                                onClick: ($event) => (_ctx.deleteModel(item))
                                                            }, {
                                                                default: _withCtx(() => [...(_cache[50] || (_cache[50] = [
                                                                        _createElementVNode("span", { class: "fa fa-trash" }, null, -1 /* CACHED */),
                                                                        _createTextVNode(" Delete\r\n\t\t\t\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)
                                                                    ]))]),
                                                                _: 1 /* STABLE */
                                                            }, 8 /* PROPS */, ["onClick"])
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"])
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */)
                                        ]),
                                        _cache[54] || (_cache[54] = _createTextVNode()),
                                        (_ctx.isVisibleModel('ModelName'))
                                            ? (_openBlock(), _createElementBlock("td", _hoisted_46, [
                                                _createVNode(_component_router_link, {
                                                    to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0, 'id': item.modelId } },
                                                    class: "blue hidden-sm"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]),
                                                _cache[53] || (_cache[53] = _createTextVNode()),
                                                _createElementVNode("div", _hoisted_47, [
                                                    _createVNode(_component_router_link, {
                                                        to: { name: 'model', params: { 'companyId': _ctx.query.companyId, 'manufacturerId': 0, 'id': item.modelId } },
                                                        class: "lead"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(item.modelName), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                ])
                                            ]))
                                            : _createCommentVNode("v-if", true)
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[57] || (_cache[57] = _createTextVNode()),
                            _createElementVNode("tfoot", null, [
                                (_ctx.noModelsData)
                                    ? (_openBlock(), _createElementBlock("tr", _hoisted_48, [...(_cache[55] || (_cache[55] = [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "2"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no controller models matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ], -1 /* CACHED */)
                                        ]))]))
                                    : _createCommentVNode("v-if", true)
                            ])
                        ])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted && _ctx.viewMode === 'batteryMonitor']
                ])
            ])
        ])
    ]));
}
